<template>
	<div class="photo-slideshow" v-if="this.show">
		<div class="backdrop"></div>
		<i class="wa-icon-close" @click="toggle"></i>

		<div class="big" v-touch:swipe.left="next" v-touch:swipe.right="prev">
			<span class="arrow-left" @click="prev">
				<i class="wa-icon-long-arrow-left"></i>
			</span>
			<span class="arrow-right" @click="next">
				<i class="wa-icon-long-arrow-right"></i>
			</span>
			<div class="photo">
				<img v-if="currentPhoto !== null" :src="(currentPhoto.source === 'giata' ? $cdn.giata : $cdn.default) + currentPhoto.prefix +currentPhoto.image + (currentPhoto.source === 'giata' ? '&' : '?') + 'width=1000&height=570'" @load="showDescription = true;loading = false;" :alt="currentPhoto.description" />
				<i class="fa fa-spinner fa-spin" v-if="loading"></i>

				<p v-if="currentPhoto.description && showDescription === true">
					{{ currentPhoto.description }}
				</p>
			</div>
		</div>

		<div class="preview">
			<ul class="photos">
				<li v-for="(photo, photoIndex) in allPhotos" v-bind:class="{ active: photo.id === currentPhoto.id }" @click.prevent="currentPhotoIndex = photoIndex">
					<img :src="(photo.source === 'giata' ? $cdn.giata : $cdn.default) + photo.prefix + photo.image + (photo.source === 'giata' ? '&' : '?') + 'width=120&height=90'" :alt="photo.description" />
				</li>
			</ul>
		</div>
	</div>
</template>

<script>

export default {
	props: ['photos', 'prefix'],
	data: function() {
		return {
			currentPhotoIndex: null,
			showDescription: false,
			show: false,
			loading: false
		}
	},
	mounted: function() {
		document.body.addEventListener('keyup', e => {
			// Esc
			if (e.keyCode === 27) {
				this.show = false;
			}

			// Left arrow
			if (e.keyCode === 37) {
				this.prev();
			}

			// Right arrow
			if (e.keyCode === 39) {
				this.next();
			}
		})
	},
	computed: {
		currentPhoto: function() {
			var photo = this.photos[this.currentPhotoIndex];

			if (typeof(photo) !== 'undefined') {
				// Prefix
				if (typeof(photo.prefix) === 'undefined') {
					photo['prefix'] = this.prefix;
				}
			}

			return photo;
		},
		allPhotos: function() {
			var allPhotos = this.photos.slice();

			for (var i = 0; i < allPhotos.length; i++) {
				if (typeof(allPhotos[i].prefix) === 'undefined') {
					allPhotos[i]['prefix'] = this.prefix;
				}
			}

			return allPhotos;
		}
	},
	methods: {
		toggle: function() {
			this.show = !this.show;
		},
		showPhoto: function(id) {
			for (var i = 0; i < this.photos.length; i++) {
				if (this.photos[i].id === id)
					this.currentPhotoIndex = i;
			}

			this.toggle();
		},
		next: function() {
			this.showDescription = false;

			var nextIndex = (this.currentPhotoIndex + 1 < this.photos.length ? this.currentPhotoIndex + 1 : 0);
			this.currentPhotoIndex = nextIndex;

			var scrollLeft = (nextIndex - 1) * ($(this.$el).find('ul.photos > li').eq(0).width() + 5);
			$(this.$el).find('ul.photos').stop().animate({ scrollLeft: scrollLeft }, 300);
		},
		prev: function() {
			this.showDescription = false;

			var nextIndex = (this.currentPhotoIndex - 1 >= 0 ? this.currentPhotoIndex - 1 : this.photos.length - 1);
			this.currentPhotoIndex = nextIndex;

			var scrollLeft = (nextIndex - (nextIndex > 0 ? 1 : 0)) * ($(this.$el).find('ul.photos > li').eq(0).width() + 5);
			$(this.$el).find('ul.photos').stop().animate({ scrollLeft: scrollLeft }, 300);
		}
	},
	watch: {
		currentPhoto: function() {
			this.loading = true;
		}
	}
}
</script>
